import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { DataExtractionService } from '@/infra/services/data-extraction';
import { DataExtractionBaseParams } from '@/types/entities/DataExtraction';

type GetDataExtractionListParams = DataExtractionBaseParams & {
	page?: number;
	limit?: number;
};

const Service = DataExtractionService.getInstance();

export function useGetDataExtractionList(params: GetDataExtractionListParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_DATA_EXTRACTION_LIST, params],
		queryFn: async () => Service.findAll(params),
		enabled: !!params.organization_id && !!params.company_id
	});
}
